import React from 'react';
import { CTAButton } from './CTAButton';
export function PriceReveal() {
  return <section id="pricing-section" className="bg-cream-light py-[100px] px-5 text-center" data-id="element-465">
      <div className="max-w-[800px] mx-auto" data-id="element-466">
        <h2 className="font-serif text-[36px] md:text-[40px] text-primary-dark mb-12" data-id="element-467">
          Your Investment Today
        </h2>

        <div className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.1)] p-[40px] md:p-[60px_40px] max-w-[480px] mx-auto mb-12" data-id="element-468">
          <p className="font-sans text-[22px] text-blood-red/80 line-through mb-4 font-bold tracking-wide" data-id="element-469">
            $189 <span className="text-[16px] font-normal" data-id="element-470">total value</span>
          </p>
          <div className="font-serif text-[64px] md:text-[80px] text-primary-dark leading-none mb-6" data-id="element-471">
            $9.99
          </div>
          <p className="font-sans text-[14px] text-primary-dark/60 mb-2" data-id="element-472">
            Complete digital system · PDF + all 19 tools
          </p>
          <p className="font-sans text-[14px] text-primary-dark/60 mb-8" data-id="element-473">
            Instant download · Works on any device · Yours forever
          </p>

          <CTAButton subText="PDF instant delivery · Start in 5 minutes" className="w-full" isCheckout data-id="element-474">
            DOWNLOAD THE SYSTEM NOW — $9.99
          </CTAButton>
        </div>

        <div className="font-sans text-[17px] text-primary-dark/70 leading-relaxed" data-id="element-475">
          <p data-id="element-476">Less than one DoorDash delivery. 🍕</p>
          <p data-id="element-477">Less than two gas station coffees. ☕</p>
          <p className="mb-6" data-id="element-478">Less than the late fee you paid last month. 💳</p>

          <p className="font-bold text-primary-dark text-[19px]" data-id="element-479">
            Chapter 5 alone saves you $50–$100.
            <br data-id="element-480" />
            In 12 minutes. On your first call.
            <br data-id="element-481" />
            The math isn't close.
          </p>
        </div>
      </div>
    </section>;
}